// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatDataType.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import { isEmpty } from 'lodash/fp';

export default class FormatDataType {
  format: string = null;
  formatId: string = null;
  jsFormatString: string = null;
  groupBy: string = null;
  formatDataType: string = null;

  constructor(formatValue: any) {
    this.update(formatValue);
  }

  /**
   * Update format value
   * @param {any} formatValue
   */
  update(formatValue: any): void {
    if (isEmpty(formatValue)) {
      return;
    }

    const { format, formatId, jsFormatString, groupBy, formatDataType } = formatValue;
    if (isEmpty(formatId)) {
      this.reset();
    } else {
      this.format = format;
      this.formatId = formatId;
      this.jsFormatString = jsFormatString;
      this.groupBy = groupBy;
      this.formatDataType = formatDataType;
    }
  }

  /**
   * Reset format value
   */
  reset(): void {
    this.format = null;
    this.formatId = null;
    this.jsFormatString = null;
    this.groupBy = null;
    this.formatDataType = null;
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.FormatDataType.js